/**   Bug #441  
  * @Author Anupama P  
  * @Date 15 juul 2021 
  * */
import { faPrint } from '@fortawesome/free-solid-svg-icons';
import { Button, FontAwesomeIcon } from 'components';
import { useEffect, useState } from 'react';
import { useReactToPrint } from 'react-to-print';
import style from './style/print.module.scss';

const PrintButton = ({ componentRef, iconStyle = null, className = null, label = 'Print', hideLabel = false }) => {
  const handlePrint = useReactToPrint({
    content: () => componentRef.current,
  });
  const [buttonLabel, setButtonLabel] = useState(label);

  useEffect(() => {
    setButtonLabel(hideLabel ? "" : label);
  }, []);

  return (
    <Button
      type="primary" ghost
      className={`btn-primary mr-1 ${className}`}
      icon={<FontAwesomeIcon icon={faPrint} className={`${!hideLabel ? `${style.printButton}`: ""} ${iconStyle}`} />}
      onClick={handlePrint}>{buttonLabel}
    </Button>
  )
}

export default PrintButton;
